/*! popups@0.0.1-beta8 | https://github.com/JudasSong/angular-ngpopup */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require,module */
	__webpack_require__(13);
	__webpack_require__(10);
	__webpack_require__(11);
	__webpack_require__(12);
	__webpack_require__(15);
	module.exports = {};// webpack

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".ui-popup{display:none;position:absolute;font-family:Helvetica,arial,sans-serif}.ui-popup:focus{outline:0}.ui-popup-show{display:block}.ui-popup-modal:before{content:\"\";position:fixed;left:0;right:0;top:0;bottom:0;background:#000;opacity:.7;transform:scale(3);animation:ui-popup-opacity .15s 1 linear}.ui-popup-modal>*{position:relative}@keyframes ui-popup-opacity{0%{opacity:0}to{opacity:.7}}", ""]);
	
	// exports


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require,module */
	
	'use strict';
	
	var angular = __webpack_require__(5);
	var $ = angular.element;
	var Popup = __webpack_require__(14);
	var ngModule = __webpack_require__(6);
	var noop = function () {
	};
	
	
	ngModule.createPopup = function (name, options) {
	    return ngModule.directive(name, function () {
	
	        var directive = {
	            template: options.template,
	            restrict: 'AE',
	            transclude: true,
	            replace: true,
	            scope: {
	                'ngIf': '=',
	                'ngShow': '=',
	                'ngHide': '=',
	                'close': '&',
	                'confirm': "@",  // 确认回调
	                'closeAction': '@', // 关闭对话框的动作
	                'for': '@', // 吸附到指定 ID 元素
	                'align': '@', // 对齐方式，配合 `for` 才能使用
	                'fixed': '@', // 是否固定定位（跟随滚动条）
	                'modal': '@', // 是否是模态浮层
	                'duration': '@', // 显示持续时间
	                'htitle': '=', // 标题
	                'width': '@width', // 窗口宽
	                'height': '@height', // 窗口高
	                'confirmText': '@confirmText', // 确认按钮名称
	                'closeText': '@closeText', // 关闭按钮名称
	                'otherbtnText': '@otherbtnText', // 第三个按钮名称
	                'controller': "@" // 控制器
	            },
	            controller: ['$scope', function ($scope) {
	                // 默认的触发关闭动作
	                this.closeAction = ['esc', 'timeout'];
	
	                this.close = function (isUiEvent) {
	                    $scope.close();
	                    if (isUiEvent) {
	                        $scope.$apply();
	                    }
	                };
	
	                this.confirm = function () {
	                    // 通过controller来获取Angular应用
	                    var busScope = getScope($scope.controller);
	                    if ($scope.controller.indexOf('as') !== -1) {
	                        var indexAs = $scope.controller.lastIndexOf('as');
	                        busScope[$scope.controller.substring(indexAs + 3)][$scope.confirm]($scope);
	                    } else {
	                        busScope[$scope.confirm]($scope);
	                    }
	                }
	            }],
	            link: function (scope, elem, attrs, controller) {
	                var popup = new Popup({
	                    node: elem[0],
	                    fixed: attrToBoolean(attrs.fixed),
	                    align: attrs.align,
	                    showElement: noop,
	                    hideElement: noop,
	                    removeElement: noop
	                });
	
	                var temp = fix(elem);
	                var $document = $(document);
	
	                if (attrs.closeAction) {
	                    controller.closeAction = attrs.closeAction.split(/\s+/);
	                }
	
	                // 模型同步UI显示、隐藏事件
	                if (attrs.ngIf) scope.$watch('ngIf', change);
	                if (attrs.ngShow) scope.$watch('ngShow', change);
	                if (attrs.ngHide) scope.$watch('ngHide', function (value) {
	                    change(!value);
	                });
	
	                // ng 销毁事件控制对话框关闭
	                // 控制器销毁或者 ng-if="false" 都可能触发此
	                // scope.$on('$destroy', callback) >> 这种方式对 ngAnimate 支持不好
	                elem.one('$destroy', function () {
	                    change(false);
	                    popup.remove();
	                    temp.remove();
	                    changeElementClass(); // 切换遮罩显示在最顶层弹窗元素
	                });
	
	                // UI 的显示与隐藏、删除事件
	                function change(open) {
	
	                    var anchor = getAnchor(attrs['for']);
	
	                    if (angular.isUndefined(open)) {
	                        return;
	                    }
	
	                    if (angular.isObject(open)) {
	                        // HTMLElement, Event
	                        anchor = open;
	                    }
	
	                    if (open) {
	                        // 使用 setTimeout 等待 ng-show 在 UI 上生效
	                        elem.css('visibility', 'hidden');
	                        setTimeout(function () {
	                            elem.css('visibility', 'visible');
	                            popup[attrToBoolean(attrs.modal) ? 'showModal' : 'show'](anchor);
	                            setEvent(open);
	                        }, 0);
	                    } else {
	                        popup.close();
	                        setEvent(open);
	                    }
	
	                    changeElementClass(); // 切换遮罩显示在最顶层弹窗元素
	                }
	
	                function getAnchor(id) {
	                    return document.getElementById(id);
	                }
	
	                function attrToBoolean(value) {
	                    return typeof value === 'string';
	                }
	
	                // ESC 快捷键关闭浮层
	                function esc(event) {
	                    var target = event.target;
	                    var nodeName = target.nodeName;
	                    var rinput = /^input|textarea$/i;
	                    var isBlur = Popup.current === popup;
	                    var isInput = rinput.test(nodeName) && target.type !== 'button';
	                    var keyCode = event.keyCode;
	
	                    // 避免输入状态中 ESC 误操作关闭
	                    if (!isBlur || isInput) {
	                        return;
	                    }
	
	                    if (keyCode === 27) {
	                        controller.close(event);
	                    }
	                }
	
	                // 外部点击关闭
	                function outerclick(event) {
	                    if (!elem[0].contains(event.target)) {
	                        controller.close(event);
	                    }
	                }
	
	                // 定时关闭
	                function timeout() {
	                    if (attrs.duration) {
	                        timeout.timer = setTimeout(function () {
	                            controller.close(true);
	                        }, Number(attrs.duration));
	                    }
	                }
	
	                function setEvent(open) {
	                    controller.closeAction.forEach(function (action) {
	                        switch (action) {
	                            case 'esc':
	                                if (open) {
	                                    $document.on('keydown', esc);
	                                } else {
	                                    $document.off('keydown', esc);
	                                }
	                                break;
	                            case 'timeout':
	                                if (open) {
	                                    timeout();
	                                } else {
	                                    clearTimeout(timeout.timer);
	                                }
	                                break;
	                            case 'outerchick':
	                                if (open) {
	                                    $document
	                                        .on('ontouchend', outerclick)
	                                        .on('click', outerclick);
	                                } else {
	                                    $document
	                                        .off('ontouchend', outerclick)
	                                        .off('click', outerclick);
	                                }
	                                break;
	                            case 'click':
	                                //case 'focusout': // Error: [$rootScope:inprog]
	                                if (open) {
	                                    elem.on(action, controller.close);
	                                } else {
	                                    elem.off(action, controller.close);
	                                }
	                                break;
	                        }
	                    });
	                }
	
	                (options.link || function () {
	                }).apply(this, arguments);
	            }
	        };
	
	        angular.extend(directive.scope, options.scope);
	
	        return directive;
	    });
	};
	
	// scope
	function getScope(controller) {
	    // 通过controller来获取Angular应用
	    var controllerElement = document.querySelector('[ng-controller="' + controller + '"]');
	    // 获取$scope变量
	    var scope = angular.element(controllerElement).scope();
	    return scope;
	}
	
	// 切换遮罩显示在最顶层弹窗元素
	function changeElementClass() {
	    var uiPop = document.querySelectorAll('.ui-popup');
	    var len = uiPop.length;
	    if (len > 1) {
	        for (var i = 0; i < uiPop.length; i++) {
	            uiPop[i].classList.remove("ui-popup-modal");
	        }
	        uiPop[uiPop.length - 1].classList.add("ui-popup-modal");
	    } else if (len === 1) {
	        uiPop[0].classList.add("ui-popup-modal");
	    }
	}
	
	// AngularJS(v1.4.8) BUG：
	// 如果指令内部把 DOM 节点迁移到 document.body 下，
	// 则指令元素的 ng-if 为 false 的时候可能导致其他 popups 节点被 AngularJS 删除
	function fix(elem) {
	    var temp = document.createElement('popup');
	    document.body.appendChild(temp);
	    temp.appendChild(elem[0]);
	    return $(temp);
	}
	
	module.exports = ngModule;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = angular;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5).module('angular-popups', []);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	exports.i(__webpack_require__(1), "");
	
	// module
	exports.push([module.id, "body,html{-webkit-tap-highlight-color:rgba(255,255,255,0)}.ui-bubble{position:relative;background:hsla(50,89%,93%,.9);border:1px solid rgba(206,157,72,.7);border-radius:3px;outline:0;background-clip:padding-box;line-height:1.428571429;color:#cd9c4f}.ui-popup-focus .ui-bubble{box-shadow:0 0 5px rgba(0,0,0,.1)}.ui-bubble-content{padding:5px}.ui-popup-top-left .ui-bubble,.ui-popup-top-right .ui-bubble,.ui-popup-top .ui-bubble{top:-5px}.ui-popup-bottom-left .ui-bubble,.ui-popup-bottom-right .ui-bubble,.ui-popup-bottom .ui-bubble{top:5px}.ui-popup-left-bottom .ui-bubble,.ui-popup-left-top .ui-bubble,.ui-popup-left .ui-bubble{left:-5px}.ui-popup-right-bottom .ui-bubble,.ui-popup-right-top .ui-bubble,.ui-popup-right .ui-bubble{left:5px}.ui-bubble:after,.ui-bubble:before{content:\"\";position:absolute;display:none;width:0;height:0;overflow:hidden;border:5px dashed transparent}.ui-popup-anchor .ui-bubble:after,.ui-popup-anchor .ui-bubble:before{display:block}.ui-popup-top-left .ui-bubble:before,.ui-popup-top-right .ui-bubble:before,.ui-popup-top .ui-bubble:before{bottom:-10px;border-top:5px solid #cd9c4f}.ui-popup-top-left .ui-bubble:after,.ui-popup-top-right .ui-bubble:after,.ui-popup-top .ui-bubble:after{bottom:-9px;border-top:5px solid #fdf8df}.ui-popup-top-left .ui-bubble:after,.ui-popup-top-left .ui-bubble:before{left:9px}.ui-popup-top .ui-bubble:after,.ui-popup-top .ui-bubble:before{left:50%;margin-left:-5px}.ui-popup-top-right .ui-bubble:after,.ui-popup-top-right .ui-bubble:before{right:9px}.ui-popup-bottom-left .ui-bubble:before,.ui-popup-bottom-right .ui-bubble:before,.ui-popup-bottom .ui-bubble:before{top:-10px;border-bottom:5px solid #cd9c4f}.ui-popup-bottom-left .ui-bubble:after,.ui-popup-bottom-right .ui-bubble:after,.ui-popup-bottom .ui-bubble:after{top:-9px;border-bottom:5px solid #fdf8df}.ui-popup-bottom-left .ui-bubble:after,.ui-popup-bottom-left .ui-bubble:before{left:9px}.ui-popup-bottom .ui-bubble:after,.ui-popup-bottom .ui-bubble:before{margin-left:-5px;left:50%}.ui-popup-bottom-right .ui-bubble:after,.ui-popup-bottom-right .ui-bubble:before{right:9px}.ui-popup-left-bottom .ui-bubble:before,.ui-popup-left-top .ui-bubble:before,.ui-popup-left .ui-bubble:before{right:-10px;border-left:5px solid #cd9c4f}.ui-popup-left-bottom .ui-bubble:after,.ui-popup-left-top .ui-bubble:after,.ui-popup-left .ui-bubble:after{right:-9px;border-left:5px solid #fdf8df}.ui-popup-left-top .ui-bubble:after,.ui-popup-left-top .ui-bubble:before{top:9px}.ui-popup-left .ui-bubble:after,.ui-popup-left .ui-bubble:before{margin-top:-5px;top:50%}.ui-popup-left-bottom .ui-bubble:after,.ui-popup-left-bottom .ui-bubble:before{bottom:9px}.ui-popup-right-bottom .ui-bubble:before,.ui-popup-right-top .ui-bubble:before,.ui-popup-right .ui-bubble:before{left:-10px;border-right:5px solid #cd9c4f}.ui-popup-right-bottom .ui-bubble:after,.ui-popup-right-top .ui-bubble:after,.ui-popup-right .ui-bubble:after{left:-9px;border-right:5px solid #fdf8df}.ui-popup-right-top .ui-bubble:after,.ui-popup-right-top .ui-bubble:before{top:9px}.ui-popup-right .ui-bubble:after,.ui-popup-right .ui-bubble:before{margin-top:-5px;top:50%}.ui-popup-right-bottom .ui-bubble:after,.ui-popup-right-bottom .ui-bubble:before{bottom:9px}", ""]);
	
	// exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	exports.i(__webpack_require__(1), "");
	
	// module
	exports.push([module.id, ".ui-dialog{position:relative;background-color:#fff;border:1px solid rgba(0,0,0,.3);border-radius:4px;outline:0;background-clip:padding-box;font-size:14px;line-height:1.428571429;text-align:left;color:#333}@media (max-width:768px){.ui-dialog{width:90vw}}.ui-popup-focus .ui-dialog{box-shadow:0 0 8px rgba(0,0,0,.1)}.ui-popup-modal .ui-dialog{box-shadow:none}.ui-dialog-header{white-space:nowrap;background-color:#0077d6}.ui-dialog-header:after{content:\"\";display:block;height:0;border-bottom:1px solid #e5e5e5}.ui-dialog-close{position:absolute;float:right;top:8px;right:13px;padding:0 4px;font-size:24px;font-weight:500;line-height:1;color:#fff;text-shadow:0 1px 0 #fff;opacity:1;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;-webkit-tap-highlight-color:rgba(255,255,255,0)}.ui-dialog-close:active,.ui-dialog-close:focus,.ui-dialog-close:hover{color:#000;text-decoration:none;cursor:pointer;outline:0;opacity:.5}.ui-dialog-title{margin:0;line-height:40px;height:40px;padding:0 15px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;cursor:default;font-size:14px;font-weight:500;color:#fff}.ui-dialog-body{padding:0;text-align:center}.ui-dialog-body .messagerWrap{overflow:auto}.ui-dialog-content{display:inline-block;position:relative;vertical-align:middle;text-align:left;overflow-y:auto}.ui-dialog-container{padding:10px}.ui-dialog-footer{padding:0 20px 20px;text-align:center}.ui-dialog-footer:after{content:\"\";display:block;clear:both;height:0;overflow:hidden}.ui-dialog-statusbar{float:left;margin-right:20px;padding:6px 0;line-height:1.428571429;font-size:14px;color:#888;white-space:nowrap}.ui-dialog-statusbar label:hover{color:#333}.ui-dialog-statusbar .label,.ui-dialog-statusbar input{vertical-align:middle}.ui-dialog-buttons{float:right;white-space:nowrap}.ui-dialog-footer .ui-dialog-btn+.ui-dialog-btn{margin-bottom:0;margin-left:5px}.ui-dialog-footer .ui-dialog-btn{width:auto;overflow:visible;display:inline-block;padding:4px 15px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.428571429;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;background-image:none;border:1px solid transparent;border-radius:2px}.ui-dialog-footer .ui-dialog-btn:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.ui-dialog-footer .ui-dialog-btn:focus,.ui-dialog-footer .ui-dialog-btn:hover{color:#333;text-decoration:none}.ui-dialog-footer .ui-dialog-btn:active{outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.ui-dialog-footer .ui-dialog-btn:disabled{pointer-events:none;cursor:not-allowed;opacity:.65;box-shadow:none}.ui-dialog-footer .ui-dialog-btn{color:#333;background-color:#fff;border-color:#ccc}.ui-dialog-footer .ui-dialog-btn:active,.ui-dialog-footer .ui-dialog-btn:focus,.ui-dialog-footer .ui-dialog-btn:hover{color:#333;background-color:#ebebeb;border-color:#adadad}.ui-dialog-footer .ui-dialog-btn:active{background-image:none}.ui-dialog-footer .ui-dialog-btn:disabled,.ui-dialog-footer .ui-dialog-btn:disabled:active,.ui-dialog-footer .ui-dialog-btn:disabled:focus,.ui-dialog-footer .ui-dialog-btn:disabled:hover{background-color:#fff;border-color:#ccc}.ui-dialog-footer .ui-dialog-btn[autofocus]{color:#fff;background-color:#1e9fff;border-color:#1e9fff}.ui-dialog-footer .ui-dialog-btn[autofocus]:active,.ui-dialog-footer .ui-dialog-btn[autofocus]:focus,.ui-dialog-footer .ui-dialog-btn[autofocus]:hover{color:#fff;background-color:#398bfb;border-color:#398bfb}.ui-dialog-footer .ui-dialog-btn[autofocus]:active{background-image:none}.ui-popup-top-left .ui-dialog,.ui-popup-top-right .ui-dialog,.ui-popup-top .ui-dialog{top:-8px}.ui-popup-bottom-left .ui-dialog,.ui-popup-bottom-right .ui-dialog,.ui-popup-bottom .ui-dialog{top:8px}.ui-popup-left-bottom .ui-dialog,.ui-popup-left-top .ui-dialog,.ui-popup-left .ui-dialog{left:-8px}.ui-popup-right-bottom .ui-dialog,.ui-popup-right-top .ui-dialog,.ui-popup-right .ui-dialog{left:8px}.ui-dialog:after,.ui-dialog:before{content:\"\";position:absolute;display:none;width:0;height:0;overflow:hidden;border:8px dashed transparent}.ui-popup-anchor .ui-dialog:after,.ui-popup-anchor .ui-dialog:before{display:block}.ui-popup-top-left .ui-dialog:before,.ui-popup-top-right .ui-dialog:before,.ui-popup-top .ui-dialog:before{bottom:-16px;border-top:8px solid #7c7c7c}.ui-popup-top-left .ui-dialog:after,.ui-popup-top-right .ui-dialog:after,.ui-popup-top .ui-dialog:after{bottom:-15px;border-top:8px solid #fff}.ui-popup-top-left .ui-dialog:after,.ui-popup-top-left .ui-dialog:before{left:15px}.ui-popup-top .ui-dialog:after,.ui-popup-top .ui-dialog:before{left:50%;margin-left:-8px}.ui-popup-top-right .ui-dialog:after,.ui-popup-top-right .ui-dialog:before{right:15px}.ui-popup-bottom-left .ui-dialog:before,.ui-popup-bottom-right .ui-dialog:before,.ui-popup-bottom .ui-dialog:before{top:-16px;border-bottom:8px solid #7c7c7c}.ui-popup-bottom-left .ui-dialog:after,.ui-popup-bottom-right .ui-dialog:after,.ui-popup-bottom .ui-dialog:after{top:-15px;border-bottom:8px solid #fff}.ui-popup-bottom-left .ui-dialog:after,.ui-popup-bottom-left .ui-dialog:before{left:15px}.ui-popup-bottom .ui-dialog:after,.ui-popup-bottom .ui-dialog:before{margin-left:-8px;left:50%}.ui-popup-bottom-right .ui-dialog:after,.ui-popup-bottom-right .ui-dialog:before{right:15px}.ui-popup-left-bottom .ui-dialog:before,.ui-popup-left-top .ui-dialog:before,.ui-popup-left .ui-dialog:before{right:-16px;border-left:8px solid #7c7c7c}.ui-popup-left-bottom .ui-dialog:after,.ui-popup-left-top .ui-dialog:after,.ui-popup-left .ui-dialog:after{right:-15px;border-left:8px solid #fff}.ui-popup-left-top .ui-dialog:after,.ui-popup-left-top .ui-dialog:before{top:15px}.ui-popup-left .ui-dialog:after,.ui-popup-left .ui-dialog:before{margin-top:-8px;top:50%}.ui-popup-left-bottom .ui-dialog:after,.ui-popup-left-bottom .ui-dialog:before{bottom:15px}.ui-popup-right-bottom .ui-dialog:before,.ui-popup-right-top .ui-dialog:before,.ui-popup-right .ui-dialog:before{left:-16px;border-right:8px solid #7c7c7c}.ui-popup-right-bottom .ui-dialog:after,.ui-popup-right-top .ui-dialog:after,.ui-popup-right .ui-dialog:after{left:-15px;border-right:8px solid #fff}.ui-popup-right-top .ui-dialog:after,.ui-popup-right-top .ui-dialog:before{top:15px}.ui-popup-right .ui-dialog:after,.ui-popup-right .ui-dialog:before{margin-top:-8px;top:50%}.ui-popup-right-bottom .ui-dialog:after,.ui-popup-right-bottom .ui-dialog:before{bottom:15px}.ui-dialog-loading{vertical-align:middle;display:inline-block;overflow:hidden;width:32px;height:32px;font-size:0;text-indent:-999em;color:#666;width:100%\\9;text-indent:0\\9;line-height:32px\\9;text-align:center\\9;font-size:12px\\9}.ui-dialog-loading:after{position:absolute;content:\"\";width:3px;height:3px;margin:14.5px 0 0 14.5px;border-radius:100%;box-shadow:0 -10px 0 1px #ccc,10px 0 #ccc,0 10px #ccc,-10px 0 #ccc,-7px -7px 0 .5px #ccc,7px -7px 0 1.5px #ccc,7px 7px #ccc,-7px 7px #ccc;-webkit-transform:rotate(1turn);-webkit-animation:ui-dialog-loading 1.5s infinite linear;transform:rotate(1turn);animation:ui-dialog-loading 1.5s infinite linear;display:none\\9}@keyframes ui-dialog-loading{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	exports.i(__webpack_require__(1), "");
	
	// module
	exports.push([module.id, ".ui-notice{padding:10px;border:1px solid #000;border-radius:5px;background:rgba(0,0,0,.7);color:#fff}", ""]);
	
	// exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require */
	
	'use strict';
	
	__webpack_require__(16);
	
	var directives = __webpack_require__(3);
	
	directives.createPopup('bubble', {
	    template: '<div class="ui-popup">' +
	        '<div class="ui-bubble">' +
	        '<div ng-transclude class="ui-bubble-content"></div>' +
	        '</div>' +
	        '</div>',
	    link: function(scope, elem, attrs, controller) {
	        if (!attrs.closeAction) {
	            controller.closeAction = ['esc', 'timeout', 'outerchick'];
	        }
	    }
	});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require */
	
	'use strict';
	
	__webpack_require__(17);
	var angular = __webpack_require__(5);
	var $ = angular.element;
	var directives = __webpack_require__(3);
	
	var dialogTpl =
	    '<div class="ui-popup" aria-labelledby="{{$dialogId}}-title" aria-describedby="{{$dialogId}}-content">' +
	    '<div class="ui-dialog">' +
	    '<div class="ui-dialog-header">' +
	    '<div class="ui-dialog-title" id="{{$dialogId}}-title">{{htitle}}</div>' +
	    '<a class="ui-dialog-close" ng-click="$close()">&times;</span></a>' +
	    '</div>' +
	    '<div class="ui-dialog-body">' +
	    '<div class="ui-dialog-content" id="{{$dialogId}}-content" ng-transclude style="width: {{width}};height: {{height}};"></div>' +
	    '</div>' +
	    '<div class="ui-dialog-footer">' +
	    '<div class="ui-dialog-buttons">' +
	    '<a class="ui-dialog-btn" autofocus ng-if="confirmText" ng-click="$confirm()">{{confirmText}}</a>' +
	    '<a class="ui-dialog-btn" ng-if="closeText" ng-click="$close()">{{closeText}}</a>' +
	    '</div>' +
	    '</div>' +
	    '</div>' +
	    '</div>';
	
	directives.createPopup('dialog', {
	    template: dialogTpl,
	    link: function (scope, elem, attrs, controller) {
	        var node = elem[0];
	        scope.$dialogId = 'ui-dialog' + scope.$id;
	        scope.$confirm = controller.confirm;
	        scope.$close = controller.close;
	    }
	});
	
	var dialogPopupTpl =
	    '<div class="ui-popup" aria-labelledby="{{$dialogId}}-title" aria-describedby="{{$dialogId}}-content" ng-transclude></div>';
	
	directives.createPopup('dialogPopup', {
	    template: dialogPopupTpl,
	    link: function (scope, elem, attrs, controller) {
	        var node = elem[0];
	        scope.$dialogId = 'ui-dialog' + scope.$id;
	    }
	});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require */
	
	'use strict';
	
	__webpack_require__(18);
	
	var directives = __webpack_require__(3);
	
	directives.createPopup('notice', {
	    template: '<div class="ui-popup">' +
	        '<div class="ui-notice" ng-transclude>' +
	        '</div>' +
	        '</div>'
	});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require */
	
	'use strict';
	
	__webpack_require__(19);
	
	var directives = __webpack_require__(3);
	
	directives.createPopup('popup', {
	    template: '<div class="ui-popup"><div ng-transclude></div></div>'
	});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/* global module */
	
	'use strict';
	
	
	/**
	 * @param   {HTMLElement}   浮层元素（可选）
	 */
	function Popup(options) {
	
	    // 合并默认配置
	    this.options = Object.create(Popup.defaults);
	    Object.keys(options || {}).forEach(function (key) {
	        var value = options[key];
	        if (typeof value !== 'undefined') {
	            this.options[key] = value;
	        }
	    }, this);
	
	
	    var node = this.options.node || document.createElement('div');
	    node.style.position = 'absolute';
	    node.setAttribute('tabindex', '-1');
	    document.body.appendChild(node);
	
	    this.options.hideElement(node);
	    this.node = node;
	    this.destroyed = false;
	}
	
	
	Popup.defaults = {
	    /** 浮层 DOM 素节点 */
	    node: null,
	
	    /** 是否开启固定定位 */
	    fixed: false,
	
	    /** 是否自动聚焦 */
	    autofocus: true,
	
	    /** 对齐方式 */
	    align: 'bottom left',
	
	    /** CSS 类名 */
	    className: 'ui-popup',
	
	    showElement: showElement,
	    hideElement: hideElement,
	    removeElement: removeElement
	};
	
	
	Popup.prototype = {
	
	    constructor: Popup,
	
	    /** 判断是否删除[只读] */
	    destroyed: true,
	
	    /** 判断是否显示[只读] */
	    open: false,
	
	    /** close 返回值 */
	    returnValue: '',
	
	    /**
	     * 显示浮层
	     * @param   {HTMLElement, Event}  指定位置（可选）
	     */
	    show: function (anchor) {
	
	        if (this.destroyed) {
	            return this;
	        }
	
	        var node = this.node;
	
	        this.__activeElement = getActiveElement();
	
	        this.open = true;
	        this.anchor = anchor;
	
	
	        addClass(node, this.options.className);
	        addClass(node, this.__name('show'));
	        node.setAttribute('role', this.modal ? 'alertdialog' : 'dialog');
	
	
	        if (!this.__show) {
	            this.focus = this.focus.bind(this);
	            this.reset = this.reset.bind(this);
	            this.__show = true;
	        }
	
	
	        // 模态浮层的遮罩
	        if (this.modal) {
	
	            addClass(node, this.__name('modal'));
	
	            // 让焦点限制在浮层内
	            addEvent(document, 'focusin', this.focus);
	        }
	
	        this.options.showElement(node);
	
	        addEvent(window, 'resize', this.reset);
	
	        this.reset().focus();
	
	        return this;
	    },
	
	
	    /** 显示模态浮层。参数参见 show() */
	    showModal: function () {
	        this.modal = true;
	        return this.show.apply(this, arguments);
	    },
	
	
	    /** 关闭浮层 */
	    close: function (result) {
	
	        if (!this.destroyed && this.open) {
	
	            var node = this.node;
	
	            if (result !== undefined) {
	                this.returnValue = result;
	            }
	
	            removeClass(node, this.__name('show'));
	            removeClass(node, this.__name('modal'));
	
	            this.options.hideElement(node);
	
	            this.open = false;
	            this.blur(); // 恢复焦点，照顾键盘操作的用户
	
	            removeEvent(document, 'focusin', this.focus);
	            removeEvent(window, 'resize', this.reset);
	        }
	
	        return this;
	    },
	
	
	    /** 销毁浮层 */
	    remove: function () {
	
	        if (this.destroyed) {
	            return this;
	        }
	
	
	        if (this.open) {
	            this.close();
	        }
	
	
	        if (Popup.current === this) {
	            Popup.current = null;
	        }
	
	
	        this.options.removeElement(this.node);
	
	
	        for (var i in this) {
	            delete this[i];
	        }
	
	        return this;
	    },
	
	
	    /** 重置位置 */
	    reset: function () {
	
	        if (!this.open) {
	            return;
	        }
	
	        var anchor = this.anchor;
	
	        if (typeof anchor === 'string') {
	            anchor = this.anchor = document.querySelector(anchor);
	        }
	
	        this.node.style.position = this.options.fixed ? 'fixed' : 'absolute';
	
	        if (anchor) {
	            this.__anchor(anchor);
	        } else {
	            this.__center();
	        }
	
	        return this;
	    },
	
	
	    /** 让浮层获取焦点 */
	    focus: function () {
	        var node = this.node;
	        var current = Popup.current;
	        var index = this.zIndex = Popup.zIndex++;
	
	        if (current && current !== this) {
	            current.blur(false);
	        }
	
	        // 检查焦点是否在浮层里面
	        if (!node.contains(getActiveElement())) {
	            var autofocus = node.querySelector('[autofocus]');
	
	            if (!this.__autofocus && autofocus) {
	                this.__autofocus = true;
	            } else {
	                autofocus = node;
	            }
	
	            node.contains(autofocus) ? -1 : this.__focus(autofocus);
	        }
	
	        // 设置叠加高度
	        node.style.zIndex = index;
	
	        Popup.current = this;
	        addClass(node, this.__name('focus'));
	
	        return this;
	    },
	
	
	    /** 让浮层失去焦点。将焦点退还给之前的元素，照顾视力障碍用户 */
	    blur: function () {
	
	        var activeElement = this.__activeElement;
	        var now = getActiveElement();
	        var isBlur = arguments[0];
	        var node = this.node;
	
	        if (isBlur !== false && node.contains(now)) {
	            this.__focus(activeElement);
	        }
	
	        this.__autofocus = false;
	        removeClass(node, this.__name('focus'));
	
	        return this;
	    },
	
	
	    __name: function (name) {
	        return this.options.className + '-' + name;
	    },
	
	
	    // 对元素安全聚焦
	    __focus: function (elem) {
	        // 防止 iframe 跨域无权限报错
	        // 防止 IE 不可见元素报错
	        try {
	            // ie11 bug: iframe 页面点击会跳到顶部
	            if (this.options.autofocus && !/^iframe$/i.test(elem.nodeName)) {
	                elem.focus();
	            }
	        } catch (e) {
	        }
	    },
	
	
	    // 居中浮层
	    __center: function () {
	
	        var node = this.node;
	        var fixed = this.options.fixed;
	        var dl = fixed ? 0 : getDocumentScroll('Left');
	        var dt = fixed ? 0 : getDocumentScroll('Top');
	        var ww = getWindowSize('Width');
	        var wh = getWindowSize('Height');
	        var ow = node.offsetWidth;
	        var oh = node.offsetHeight;
	        var left = (ww - ow) / 2 + dl;
	        var top = (wh - oh) * 382 / 1000 + dt; // 黄金比例
	        var style = node.style;
	
	
	        style.left = Math.max(parseInt(left), dl) + 'px';
	        style.top = Math.max(parseInt(top), dt) + 'px';
	    },
	
	
	    // 指定位置 @param    {HTMLElement, Event}  anchor
	    __anchor: function (anchor) {
	
	        var isElem = anchor.parentNode && anchor;
	        var node = this.node;
	
	
	        if (this.__anchorClass) {
	            removeClass(node, this.__anchorClass);
	            removeClass(node, this.__name('anchor'));
	        }
	
	
	        // 隐藏元素不可用
	        if (isElem && anchor.offsetLeft * anchor.offsetTop < 0) {
	            return this.__center();
	        }
	
	        var that = this;
	        var options = this.options;
	        var fixed = options.fixed;
	
	        var winWidth = getWindowSize('Width');
	        var winHeight = getWindowSize('Height');
	        var docLeft = getDocumentScroll('Left');
	        var docTop = getDocumentScroll('Top');
	
	
	        var popupWidth = node.offsetWidth;
	        var popupHeight = node.offsetHeight;
	        var width = anchor.offsetWidth || 0;
	        var height = anchor.offsetHeight || 0;
	        var offset = getOffset();
	        var x = offset.left;
	        var y = offset.top;
	        var left = fixed ? x - docLeft : x;
	        var top = fixed ? y - docTop : y;
	
	
	        var minLeft = fixed ? 0 : docLeft;
	        var minTop = fixed ? 0 : docTop;
	        var maxLeft = minLeft + winWidth - popupWidth;
	        var maxTop = minTop + winHeight - popupHeight;
	
	
	        var css = {};
	        var align = options.align.split(' ');
	        var className = this.__name('');
	        var reverse = {
	            top: 'bottom',
	            bottom: 'top',
	            left: 'right',
	            right: 'left'
	        };
	        var name = {
	            top: 'top',
	            bottom: 'top',
	            left: 'left',
	            right: 'left'
	        };
	
	
	        var temp = [{
	            top: top - popupHeight,
	            bottom: top + height,
	            left: left - popupWidth,
	            right: left + width
	        }, {
	            top: top,
	            bottom: top - popupHeight + height,
	            left: left,
	            right: left - popupWidth + width
	        }];
	
	
	        var center = {
	            left: left + width / 2 - popupWidth / 2,
	            top: top + height / 2 - popupHeight / 2
	        };
	
	
	        var range = {
	            left: [minLeft, maxLeft],
	            top: [minTop, maxTop]
	        };
	
	
	        // 超出可视区域重新适应位置
	        align.forEach(function (val, i) {
	
	            // 超出右或下边界：使用左或者上边对齐
	            if (temp[i][val] > range[name[val]][1]) {
	                val = align[i] = reverse[val];
	            }
	
	            // 超出左或右边界：使用右或者下边对齐
	            if (temp[i][val] < range[name[val]][0]) {
	                align[i] = reverse[val];
	            }
	
	        });
	
	
	        // 一个参数的情况
	        if (!align[1]) {
	            name[align[1]] = name[align[0]] === 'left' ? 'top' : 'left';
	            temp[1][align[1]] = center[name[align[1]]];
	        }
	
	
	        if (isElem) {
	            // 添加 anchor 的 css
	            className += align.join('-');
	            that.__anchorClass = className;
	            addClass(node, className);
	            addClass(node, this.__name('anchor'));
	        }
	
	
	        css[name[align[0]]] = parseInt(temp[0][align[0]]);
	        css[name[align[1]]] = parseInt(temp[1][align[1]]);
	
	        node.style.left = css.left + 'px';
	        node.style.top = css.top + 'px';
	
	
	        // 获取元素或 Event 对象相对于页面的位置（不支持 iframe 内的元素）
	        function getOffset() {
	            if (isElem) {
	
	                var win = window;
	                var docElem = document.documentElement;
	                var box = anchor.getBoundingClientRect();
	
	                return {
	                    top: box.top + win.pageYOffset - docElem.clientTop,
	                    left: box.left + win.pageXOffset - docElem.clientLeft
	                };
	            } else {
	                return {
	                    left: anchor.pageX,
	                    top: anchor.pageY
	                };
	            }
	        }
	
	    }
	
	};
	
	
	/** 当前叠加高度 */
	Popup.zIndex = 1024;
	
	
	/** 顶层浮层的实例 */
	Popup.current = null;
	
	
	// 获取窗口大小
	function getWindowSize(name) {
	    return document.documentElement['client' + name];
	}
	
	
	// 获取页面滚动条位置
	function getDocumentScroll(name) {
	    var type = {
	        Left: 'pageXOffset',
	        Top: 'pageYOffset'
	    };
	    return window[type[name]];
	}
	
	
	// 删除节点
	function removeElement(elem) {
	    // elem.remove()
	    elem.parentNode.removeChild(elem);
	}
	
	
	// 显示节点
	function showElement(elem) {
	    elem.style.display = 'block';
	}
	
	
	// 隐藏节点
	function hideElement(elem) {
	    elem.style.display = 'none';
	}
	
	
	// 判断是否包含制定类名
	function hasClass(elem, className) {
	    // elem.contains(className)
	    return elem.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
	}
	
	
	// 添加类
	function addClass(elem, className) {
	    // elem.classList.add(className)
	    if (!hasClass(elem, className)) {
	        elem.className += ' ' + className;
	    }
	}
	
	
	// 删除类
	function removeClass(elem, className) {
	    // elem.classList.remove(className)
	    if (hasClass(elem, className)) {
	        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
	        elem.className = elem.className.replace(reg, ' ');
	    }
	}
	
	
	// 添加事件
	function addEvent(elem, type, callback) {
	    elem.addEventListener(type, callback, false);
	}
	
	
	// 删除事件
	function removeEvent(elem, type, callback) {
	    elem.removeEventListener(type, callback);
	}
	
	
	// 获取当前焦点的元素
	function getActiveElement() {
	    try { // try: ie8~9, iframe #26
	        var activeElement = document.activeElement;
	        var contentDocument = activeElement.contentDocument;
	        var elem = contentDocument && contentDocument.activeElement || activeElement;
	        return elem;
	    } catch (e) {
	    }
	}
	
	module.exports = Popup;
	
	
	// 更新记录：
	// 取消对 iframe 支持
	// follow > anchor
	// fixed 支持多次设置
	// 删除遮罩层
	// 支持传入 elem
	// 修复 resize 可能被重复监听的 BUG
	// 移除 jQuery，只支持 IE9+
	// 移除事件系统
	// 使用配置项代替属性
	
	// TODO showModal focus 优化
	// TODO zIndex 优化
	// __anchor 函数优化

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* global require */
	// TODO Popup.prompt
	
	'use strict';
	
	var angular = __webpack_require__(5);
	var ngModule = __webpack_require__(6);
	
	ngModule.provider('Popup', function () {
	
	    var that = this;
	    var compiled = false;
	    var noop = function () {
	    };
	    var defaults = {
	        title: 'Message',
	        okValue: 'Ok',
	        cancelValue: 'Cancel'
	    };
	    var model = {
	        open: true,
	        title: null,
	        content: null,
	        duration: null,
	        okValue: null,
	        cancelValue: null,
	        showBtn: true,
	        notice: false,
	        type: '',
	        longShort: "",
	        width: '280px',
	        height: "120px",
	        ok: null,
	        cancel: null,
	        $destroy: noop,
	        $ok: function () {
	            if (this.ok && this.ok() !== false) {
	                this.open = false;
	                this.$destroy();
	            }
	        },
	        $cancel: function () {
	            if (this.cancel && this.cancel() !== false) {
	                this.open = false;
	                this.$destroy();
	            }
	        },
	        $close: function () {
	            if (this.cancel) {
	                this.$cancel();
	            } else {
	                this.$ok();
	            }
	        }
	    };
	
	    var sub = {
	        close: function () {
	            model.$close();
	        }
	    };
	
	    var baseDialogTpl =
	        '<dialog-popup ng-if="$$Popup.open && !$$Popup.notice" duration="{{$$Popup.duration}}" modal fixed close="$$Popup.$close()">' +
	        '<div class="ui-dialog">' +
	        '<div class="ui-dialog-header">' +
	        '<div class="ui-dialog-title" id="{{$dialogId}}-title">{{$$Popup.title}}</div>' +
	        '<a class="ui-dialog-close" ng-click="$$Popup.$close()">&times;</span></a>' +
	        '</div>' +
	        '<div class="ui-dialog-body">' +
	        '<div class="messagerWrap messager-{{$$Popup.type}}" ng-style="{width:$$Popup.width,height:$$Popup.height}">' +
	        ' <div class="messagerCnt {{$$Popup.longShort}} clear">' +
	        ' <div class="messager-icon"><img src="/images/{{$$Popup.type}}.png" width="26"></div>' +
	        ' <div class="messager-text">{{$$Popup.content}}</div>' +
	        ' </div>' +
	        '</div>' +
	        '</div>' +
	        '<div class="ui-dialog-footer" ng-if="$$Popup.showBtn">' +
	        '<div class="ui-dialog-buttons">' +
	        '<a class="ui-dialog-btn" ng-if="$$Popup.ok" autofocus ng-click="$$Popup.$ok()">{{$$Popup.okValue}}</a>' +
	        '<a class="ui-dialog-btn" ng-if="$$Popup.cancel" ng-click="$$Popup.$cancel()">{{$$Popup.cancelValue}}</a>' +
	        '</div>' +
	        '</div>' +
	        '</div>' +
	        '</dialog-popup>';
	
	    var noticeDialogTpl =
	        '<notice ng-if="$$Popup.open && $$Popup.notice" fixed duration="{{$$Popup.duration}}" close="$$Popup.$close()">' +
	        '{{$$Popup.content}}' +
	        '</notice>';
	
	    angular.extend(this, defaults);
	
	    this.$get = [
	        '$compile',
	        '$rootScope',
	        function ($compile, $rootScope) {
	
	            function createPopup(options) {
	                if (!compiled) {
	                    var baseDialog = createElement(baseDialogTpl);
	                    document.body.appendChild(baseDialog);
	                    $compile(baseDialog)($rootScope);
	
	                    var noticeDialog = createElement(noticeDialogTpl);
	                    document.body.appendChild(noticeDialog);
	                    $compile(noticeDialog)($rootScope);
	                    compiled = true;
	                }
	
	                if (!options.notice) {
	                    var len = options.content.length;
	                    if (len > 25) {
	                        options.longShort = "";
	                        options.width = "400px";
	                        options.height = "280px";
	                    } else if (len > 15) {
	                        options.longShort = "center-long";
	                        options.width = "320px";
	                        options.height = "140px";
	                    } else if (len <= 15) {
	                        options.longShort = "center-short";
	                        options.width = "320px";
	                        options.height = "140px";
	                    }
	                }
	                var dialogModel = Object.create(model);
	                dialogModel = angular.extend(dialogModel, that, options);
	                dialogModel.$destroy = function () {
	                    delete $rootScope.$$Popup;
	                };
	
	                $rootScope.$$Popup = dialogModel;
	
	                return sub;
	            }
	
	            return {
	                alert: function (content, ok) {
	                    return createPopup({
	                        content: content,
	                        ok: ok || noop
	                    });
	                },
	                success: function (content, ok) {
	                    return createPopup({
	                        content: content,
	                        type: 'success',
	                        duration: 5000,
	                        showBtn: false,
	                        ok: ok || noop
	                    });
	                },
	                info: function (content, ok) {
	                    return createPopup({
	                        content: content,
	                        type: 'info',
	                        duration: 5000,
	                        showBtn: false,
	                        ok: ok || noop
	                    });
	                },
	                warning: function (content, ok) {
	                    return createPopup({
	                        content: content,
	                        type: 'warning',
	                        showBtn: false,
	                        ok: ok || noop
	                    });
	                },
	                fail: function (content, ok) {
	                    return createPopup({
	                        content: content,
	                        type: 'fail',
	                        showBtn: false,
	                        ok: ok || noop
	                    });
	                },
	                confirm: function (content, ok, cancel) {
	                    return createPopup({
	                        content: content,
	                        ok: ok || noop,
	                        cancel: cancel || noop
	                    });
	                },
	                notice: function (content, duration, ok) {
	                    return createPopup({
	                        content: content,
	                        duration: duration || 2000,
	                        ok: ok || noop,
	                        notice: true
	                    });
	                }
	            };
	        }];
	});
	
	
	function createElement(html) {
	    var temp = document.createElement('div');
	    temp.innerHTML = html;
	    return temp.firstChild;
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(7);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!./ui-bubble.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?minimize!./ui-bubble.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(8);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!./ui-dialog.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?minimize!./ui-dialog.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(9);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!./ui-notice.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?minimize!./ui-notice.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?minimize!./ui-popup.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?minimize!./ui-popup.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// angular-ngpopup.js